import { render } from "./AddressSettings.vue?vue&type=template&id=67fb25a2&scoped=true"
import script from "./AddressSettings.vue?vue&type=script&lang=js"
export * from "./AddressSettings.vue?vue&type=script&lang=js"

import "./AddressSettings.vue?vue&type=style&index=0&id=67fb25a2&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fb25a2"]])

export default __exports__